import { z } from "zod";

import { defineContractFromMeta } from "@shared/functions.ts";

const CONTRACT_NAME = "start-test-run";

const StartTestRunInputSchema = z.object({
  testRunId: z.string().uuid(),
});
export type StartTestRunInput = z.input<typeof StartTestRunInputSchema>;

const StartTestRunOutputSchema = z.object({
  ok: z.literal(true),
  pgflowRunId: z.string().uuid(),
});
export type StartTestRunOutput = z.output<typeof StartTestRunOutputSchema>;

const StartTestRunContract = defineContractFromMeta({
  name: CONTRACT_NAME,
  meta: import.meta,
  input: StartTestRunInputSchema,
  output: StartTestRunOutputSchema,
});

export default StartTestRunContract;
export type StartTestRunContract = typeof StartTestRunContract;
